@if(headerData()?.type === 'back_button') {
<button type="button" mat-icon-button (click)="backward()" color="primary">
    <mat-icon>west</mat-icon>
</button>
<span class="back-button-title">
    @if (headerData()?.title) {
    {{ headerData()?.title }}
    } @else {
    {{ titleService.getTitle() }}
    }
</span>
<div style="width: 48px"></div>
} @else if(headerData()?.type === 'back_button_up') {
<button type="button" mat-icon-button (click)="goUp()" color="primary">
    <mat-icon>west</mat-icon>
</button>
<span class="back-button-title">
    @if (headerData()?.title) {
    {{ headerData()?.title }}
    } @else {
    {{ titleService.getTitle() }}
    }
</span>
<div style="width: 48px"></div>
} @else {

@if (['TABLET','MOBILE'].includes(breakpointService.breakpoint())) {
<button type="button" aria-label="navigation" mat-icon-button [matMenuTriggerFor]="appMenuMobile">
    <mat-icon aria-label="Menu" color="primary">menu</mat-icon>
</button>
}

@if (breakpointService.breakpoint() === 'DESKTOP') {
<!-- on desktop devices -->
<span class="ystmTextLogo" routerLink="/">YSTM</span>
<img src="assets/img/Stander-Schatten.svg" width="806" height="536" alt="YSTM"
    style="width:84px;height:auto;margin:0 14px;" class="clickable" routerLink="/">
<span class="ystmTextLogo" routerLink="/">Yachtclub Steinhuder Meer e.V.</span>
<span class="frs"></span>
<!-- @defer(on viewport;) { -->
<app-application-toolbar-content-icon-gale-warning />
<!-- } @placeholder {
<div style="width:48px; height: 48px;"></div>
} -->
<span class="ystmPos">52°28,32'N 9°22,95'O</span>
} @else {
<!-- on mobile devices -->
<img src="assets/img/Stander-Schatten.svg" width="806" height="536" alt="YSTM" style="width:84px;height:auto;"
    class="clickable" routerLink="/">
<span class="ystmTextLogo" style="margin-left:0;" routerLink="/">YSTM</span>
<span class="frs"></span>
<!-- @defer(on viewport;) { -->
<app-application-toolbar-content-icon-gale-warning />
<!-- } @placeholder {
<div style="width:48px; height: 48px;"></div>
} -->
<!-- @defer(on viewport;) { -->
<app-application-toolbar-content-icon-news />
<!-- } @placeholder {
<div style="width:48px; height: 48px;"></div>
} -->
<!-- @defer(on viewport;) { -->
<app-application-toolbar-content-icon-weather />
<!-- } @placeholder {
<div style="width:48px; height: 48px;"></div>
} -->
}
}


<mat-menu #appMenuMobile="matMenu" class="mob-menu" overlapTrigger="false">
    <a mat-menu-item routerLink="" routerLinkActive="mob-link-active" [routerLinkActiveOptions]="{exact:true}" class="mob-link">Der Club</a>
    <a mat-menu-item routerLink="termine" routerLinkActive="mob-link-active" class="mob-link">Termine</a>
    <a mat-menu-item routerLink="boote" routerLinkActive="mob-link-active" class="mob-link">Boote</a>
    <a mat-menu-item routerLink="jugend" routerLinkActive="mob-link-active" class="mob-link">Jugend</a>
    <a mat-menu-item routerLink="regatta" routerLinkActive="mob-link-active" class="mob-link">Regatta</a>
    <a mat-menu-item routerLink="links" routerLinkActive="mob-link-active" class="mob-link">Links</a>
    <a mat-menu-item routerLink="kontakt" routerLinkActive="mob-link-active" class="mob-link">Kontakt</a>
    <a mat-menu-item routerLink="aktuell" routerLinkActive="mob-link-active" class="mob-link">News und
        nächste
        Termine</a>
    <a mat-menu-item routerLink="wetter" routerLinkActive="mob-link-active" class="mob-link">Wind & Wetter</a>
    <a mat-menu-item routerLink="videos" routerLinkActive="mob-link-active" class="mob-link">Videos</a>
    <a mat-menu-item routerLink="member" routerLinkActive="mob-link-active" class="mob-link">Mitglieder</a>
</mat-menu>